/**
 * Created by mac on 4/23/20
 */

const EditorCardTableView = CardTableView.extend({
    ctor: function (editorTable) {
        this._super(editorTable);

        this.cardBlocks = [];
        this.updateGrid(this.table.grid);

        this.table.on("recreate", this.recreate.bind(this));

        this.table.on("addEditor", (card, index) => {
            const cardView = CardView.createCardView(card);

            if (index === undefined) {
                index = this.table.cards.indexOf(card);
            }
            cardView.setLocalZOrder(index);

            cardView.setAlignment(this.convertToViewPosition(card));
            this.centerNode.addChild(cardView);

            card.components.forEach((component) => {
                const ComponentViewClass = component.getViewClass();
                const componentView = new ComponentViewClass(component);
                cardView.addChild(componentView);
            });
        });

        this.table.on("removeCardEditor", (card) => {
            const cardView = card.onGetView();
            cardView.removeFromParent();
        });

        this.table.on("editorMove", (cards, delta) => {
            cards.forEach((card) => {
                const cardView = card.onGetView();
                const base = card.getViewPosition();
                cardView.setAlignment({
                    x: base.point.x + delta.x,
                    y: base.point.y + delta.y
                });

                cardView.setRotation((card.r + delta.r) % 360);
                cardView.setLocalZOrder(card.getZ() + 10000);
            }, this);
        });

        this.table.on("editorMoveEnd", (cards) => {
            cards.forEach((card) => {
                const cardView = card.onGetView();
                cardView.setAlignment(card.getViewPosition().point);
                cardView.setRotation(card.getRotation());
                cardView.setLocalZOrder(card.getZ());
            }, this);
        });

        this.table.on("editorUpdateZ", (cards) => {
            cards.forEach((card, index) => {
                const cardView = card.onGetView();
                cardView.setLocalZOrder(index);
            }, this);
        });

        this.table.on("editorChangeOrientation", () => {
            this.updateGrid(this.table.grid);
        });

        this.table.on("drawMagicArea", this.createListener(this.drawMagicArea.bind(this)));

        this.table.on("createCardsBlocks", this.createListener(this.createBlocks.bind(this)));
        this.table.on("removeCardsBlocks", this.createListener(this.removeBlocks.bind(this)));

        this.table.on("toggleSnapMode", this.createListener(this.onToggleSnapMode.bind(this)));

        cleverapps.inputDispatcher.on("keypressed", (key) => {
            const table = Game.currentGame.table;

            if (key === InputDispatcher.KEY.a && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl)) {
                table.selectAll();
            } else if ((key === InputDispatcher.KEY.x && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl)) || key === InputDispatcher.KEY.escape) {
                table.clearSelection();
            } else if (key === InputDispatcher.KEY.backspace || key === InputDispatcher.KEY.Delete) {
                table.removeCardsEditor();
            }

            const keys = {};
            keys[InputDispatcher.KEY.up] = { x: 0, y: 1 };
            keys[InputDispatcher.KEY.down] = { x: 0, y: -1 };
            keys[InputDispatcher.KEY.left] = { x: -1, y: 0 };
            keys[InputDispatcher.KEY.right] = { x: 1, y: 0 };

            if (keys[key]) {
                const delta = cc.pMult(keys[key], table.grid.step);
                delta.r = 0;
                table.editorCardMoveEnd(delta);
            }
        }, this);
    },

    getOverlappingNodes: function () {
        return this.parent.getOverlappingNodes();
    },

    createBlocks: function (blocks) {
        blocks.forEach((block) => {
            const blockView = new EditorCardBlockView(block);
            this.cardBlocks.push(blockView);
            this.centerNode.addChild(blockView);
        });
    },

    removeBlocks: function () {
        this.cardBlocks.forEach((block) => {
            block.removeFromParent();
        });
        this.cardBlocks = [];
    },

    onToggleSnapMode: function (snapMode) {
        this.table.cards.forEach((card) => {
            const cardView = card.onGetView();
            cardView.toggleFrameVisibility(snapMode);
        });
    },

    updateGrid: function (grid) {
        if (this.gridView) {
            this.gridView.removeFromParent(true);
        }
        this.gridView = new EditorTableGridView(grid);
        this.gridView.setLocalZOrder(-1);
        this.setContentSize2(this.gridView.getContentSize());
        this.centerNode.setAlignment(this.getCenterNodePosition());
        this.addChild(this.gridView);
    },

    drawMagicArea: function (area) {
        if (this.area) {
            this.area.removeFromParent(true);
        }

        this.area = new cc.Node();
        this.addChild(this.area);
        this.area.setScale(0.99);
        this.area.setLocalZOrder(-1);

        this.area.setContentSize(area.width, area.height);
        this.area.setPosition(area.x, area.y);

        this.area.debugBorder();
    },

    getCenterNodePosition: function () {
        const grid = this.table.grid;
        return cc.p(grid.center.x * grid.step, grid.center.y * grid.step);
    },

    recreate: function (card, newCard) {
        const view = card.onGetView();
        const position = view.getPosition();
        const parent = view.getParent();
        const zOrder = view.getLocalZOrder();

        this.removeCard(card);

        const ViewClass = newCard.getViewClass();
        const newView = new ViewClass(newCard);
        newView.setPosition(position);
        parent.addChild(newView, zOrder);

        newCard.components.forEach((component) => {
            const ComponentViewClass = component.getViewClass();
            const componentView = new ComponentViewClass(component);
            newView.addChild(componentView);
            component.onShow && component.onShow();
            component.onShowUp && component.onShowUp();
        });
    },

    removeCard: function (card) {
        card.clear();
    },

    drawSelectionArea: function (rect) {
        if (!this.selectionRect) {
            this.selectionRect = cleverapps.UI.createScale9Sprite(bundles.pixel.frames.pixel_png);
            this.selectionRect.setOpacity(120);
            this.selectionRect.setAnchorPoint(0, 0);
            this.addChild(this.selectionRect, 1000);
        }
        this.selectionRect.setVisible(Boolean(rect));
        if (rect) {
            this.selectionRect.setAlignment(rect);
            this.selectionRect.setContentSize(rect);
        }
    }
});